/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
 */

import React from 'react'
import moment from 'moment'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { injectIntl } from 'react-intl'
import { Divider, FontIcon, ListItem as MaterialListItem, CircularProgress, RaisedButton } from 'material-ui'
import { TextField, DatePicker, TimePicker } from 'generic/form'
import Request from 'generic/request/Request'
import { getDateTime } from 'utils/date'

import * as headerConstants from 'constants/Header'
import * as constants from 'constants/Proposal'
import * as prestationConstants from 'constants/Prestation'
import * as actions from 'actions/Proposal'
import * as prestationActions from 'actions/ApplicantPrestation'
import * as interpreterActions from 'actions/Interpreter'

import Availability from 'components/applicant/prestation/creation/Availability'

class ProposalFormPanel extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      proposal: undefined,
      errors: {},
      loadingAvailability: false,
      availabilities: [],
      disableSubmit: false
    }

    this.handleChange = this.handleChange.bind(this)
    this.handleDateFormatChange = this.handleDateFormatChange.bind(this)
    this.handleDateChange = this.handleDateChange.bind(this)
    this.handleSetDateRef = this.handleSetDateRef.bind(this)
    this.handleTimeFormatChange = this.handleTimeFormatChange.bind(this)
    this.handleTimeChange = this.handleTimeChange.bind(this)
    this.handleSetStartRef = this.handleSetStartRef.bind(this)
    this.handleSetEndRef = this.handleSetEndRef.bind(this)
    this.handleSendProposal = this.handleSendProposal.bind(this)
    this.handleSelectAvailability = this.handleSelectAvailability.bind(this)
    this.handleChangeAvailability = this.handleChangeAvailability.bind(this)
  }


  componentDidUpdate(prevProps, prevState) {
    if (prevProps.show !== this.props.show &&
        this.props.show === true) {
      actions.getPrestationProposal()
        .then((result) => {
          this.setState({
            proposal: {
              ...result,
              uid: undefined,
              proposal_type: constants.APPLICANT_PROPOSAL_TYPE,
              prestation: this.props.prestation.uid,
              interpreter: {
                uid: this.props.prestation.interpreter.uid
              }
            }
          })
        })
    }

    if (prevProps.show !== this.props.show &&
        this.props.show === false) {
      this.setState({
        proposal: undefined,
        availabilities: [],
        errors: {}
      })
    }

    if (this.state.proposal &&
        this.state.proposal !== prevState.proposal &&
        this.state.proposal.start_date &&
        this.state.proposal.start_time &&
        this.state.proposal.end_time &&
        this.state.proposal.start_date.length === 10 &&
        this.state.proposal.start_time.length === 5 &&
        this.state.proposal.end_time.length === 5 &&
        (this.state.proposal.start_date !== prevState.start_date ||
         this.state.proposal.start_time !== prevState.start_time ||
         this.state.proposal.end_time !== prevState.end_time)) {

      const proposal = {
        ...this.state.proposal,
        uid: undefined,
        interpreter: this.props.prestation.interpreter.uid,
        start_time: getDateTime(
          moment(this.state.proposal.start_date, 'YYYY-MM-DD'),
          moment(this.state.proposal.start_time, 'HH:mm')
        ),
        end_time: getDateTime(
          moment(this.state.proposal.start_date, 'YYYY-MM-DD'),
          moment(this.state.proposal.end_time, 'HH:mm')
        )
      }

      actions.postPrestationProposalValidation(proposal)
        .then(() => {
          this.setState({
            errors: {},
            disableSubmit: false
          })
        })
        .catch(this.errorHandler)

      const availability = {
        ...proposal,
        start: proposal.start_time,
        end: proposal.end_time
      }

      this.handleChangeAvailability(availability)
    }
  }

  handleChange(name, value) {
    this.setState({
      proposal: {
        ...this.state.proposal,
        [name]: value
      },
    })
  }

  handleDateFormatChange(event, value) {
    const name = event.target.name

    this.setState({
      errors: {
        ...this.state.errors,
        [name]: undefined
      }
    })

    let date = value === '' ? undefined : value

    if (date && date.length === 10) {
      const formattedDate = moment(value, 'DD.MM.YYYY')
      if (moment(formattedDate, 'YYYY-MM-DD').isValid()) {
        date = moment(formattedDate).format('YYYY-MM-DD')
      } else {
        this.setState({
          errors: {
            ...this.state.errors,
            [name]: this.props.intl.formatMessage(prestationConstants.messages.DATE_INVALID)
          }
        })

        return
      }
    } else {
      this.setState({
        errors: {
          ...this.state.errors,
          [name]: this.props.intl.formatMessage(prestationConstants.messages.DATE_FORMAT)
        }
      })
    }

    this.handleChange(name, date)
  }

  handleDateChange(event, value) {
    const date = moment(value).format('YYYY-MM-DD')
    this.handleChange(event.target.name, date)
  }

  handleSetDateRef(field) {
    this.datePicker = field || null
  }

  handleTimeFormatChange(event, value) {
    const name = event.target.name

    this.setState({
      errors: {
        ...this.state.errors,
        [name]: undefined
      }
    })

    let time = value === '' ? undefined : value

    if (time && time.length === 5) {
      const formattedTime = moment(value, 'HH:mm')
      if (moment(formattedTime, 'HH:mm').isValid()) {
        time = moment(formattedTime)
        time = time.minute(Math.ceil(time.minute() / 5) * 5).format('HH:mm')
      } else {
        this.setState({
          errors: {
            ...this.state.errors,
            [name]: this.props.intl.formatMessage(prestationConstants.messages.TIME_INVALID)
          }
        })

        return
      }
    } else {
      this.setState({
        errors: {
          ...this.state.errors,
          [name]: this.props.intl.formatMessage(prestationConstants.messages.TIME_FORMAT)
        }
      })
    }

    this.handleChange(name, time)
  }

  handleTimeChange(event, value) {
    const time = moment(value).format('HH:mm')

    this.handleChange(event.target.name, time)
  }

  handleSetStartRef(field) {
    this.startTimePicker = field || null
  }

  handleSetEndRef(field) {
    this.endTimePicker = field || null
  }

  handleSelectAvailability(availability) {
    this.setState({
      proposal: {
        ...this.state.proposal,
        start_time: moment(availability.start).format('HH:mm'),
        end_time: moment(availability.end).format('HH:mm')
      },
    })

  }

  handleSendProposal() {
    this.setState({
      loadingAvailability: true
    })

    const startTime = getDateTime(
      moment(this.state.proposal.start_date, 'YYYY-MM-DD'),
      moment(this.state.proposal.start_time, 'HH:mm')
    )

    const endTime = getDateTime(
      moment(this.state.proposal.start_date, 'YYYY-MM-DD'),
      moment(this.state.proposal.end_time, 'HH:mm')
    )    
    
    const proposal = {
      ...this.state.proposal,
      start_time: startTime,
      end_time: endTime
    }

    actions.postPrestationProposal(proposal)
      .then(() => {
        this.props.handleProposalPanel()
      })
      .catch(this.errorHandler)
      .finally(() => {
        this.setState({
          loadingAvailability: false
        })
      })
  }

  handleChangeAvailability(availability) {
    let availabilities = []
    this.setState({
      loadingAvailability: true
    })

    const prestation = {
      ...this.props.prestation,
      ordered_date: this.state.proposal.start_date,
      ordered_start_time: moment(availability.start).format('HH:mm'),
      ordered_end_time: moment(availability.end).format('HH:mm'),
      choosenInterpreter: this.props.prestation.interpreter.uid
    }

    prestationActions.getMatchingInterpreters(prestation, prestation.address.address, this.props.user.uid)
      .then((results) => {
        availabilities = interpreterActions.getInterpreterAvailabilities(results)
      })
      .finally(() => {
        this.setState({
          availabilities: availabilities,
          loadingAvailability: false
        })
      })
  }

  errorHandler = (error) => {
    const errors = Request.getFieldErrorObject(error.response.data.field_errors)

    if (errors.proposal_notification) {
      this.props.handleProposalPanel()
      this.props.prestationActions.selectPrestation(this.props.prestation)
        .then(() => {
          this.props.prestationActions.setNotification(errors.proposal_notification, headerConstants.NOTIF_ERROR)
        })
    }

    this.setState({
      errors: errors,
      disableSubmit: true
    })

    return [errors, true]
  }

  render () {
    const date = this.state.proposal &&
                 this.state.proposal.start_date &&
                 this.state.proposal.start_date.length === 10
                  ? moment(this.state.proposal.start_date).format('DD.MM.YYYY')
                  : this.state.proposal &&
                    this.state.proposal.start_date
                    ? this.state.proposal.start_date
                    : undefined

    const startTime = this.state.proposal &&
                      this.state.proposal.start_time &&
                      this.state.proposal.length === 5
                        ? moment(this.state.proposal.start_time, 'HH:mm').format('HH:mm')
                        : this.state.proposal &&
                          this.state.proposal.start_time
                          ? this.state.proposal.start_time
                          : undefined

    const endTime = this.state.proposal &&
                    this.state.proposal.end_time &&
                    this.state.proposal.end_time.length === 5
                      ? moment(this.state.proposal.end_time, 'HH:mm').format('HH:mm')
                      : this.state.proposal &&
                        this.state.proposal.end_time
                        ? this.state.proposal.end_time
                        : undefined

    return (
      <React.Fragment>
        {
          this.props.show && this.state.proposal
            ? <React.Fragment>
              <MaterialListItem
                key={1}
                primaryText={this.props.intl.formatMessage(prestationConstants.messages.PROPOSAL_LABEL)}
                initiallyOpen={true}
                primaryTogglesNestedList={true}
                nestedItems={[
                  <div
                    key={1}
                  >
                    <div
                      className='row'
                      style={{minHeight: 90}}
                    >
                      <div
                        className='col-md-4 col-xs-12'
                        style={{position: 'relative'}}
                      >
                        <TextField
                          name='start_date'
                          value={date}
                          floatingLabelText={this.props.intl.formatMessage(prestationConstants.messages.DATE_LABEL)}
                          onChange={this.handleDateFormatChange}
                          mask='99.99.9999'
                          errorText={
                            this.state.errors
                              ? this.state.errors.start_date
                              : undefined
                          }
                          placeholderMandatory={true}
                        />

                        <DatePicker
                          name='start_date'
                          divStyle={{display: 'none'}}
                          locale={this.props.intl.locale}
                          onChange={this.handleDateChange}
                          getField={this.handleSetDateRef}
                          minDate={new Date()}
                        />

                        <FontIcon
                          onClick={() => this.datePicker.focus()}
                          className='material-icons'
                          style={{
                            margin: '20px 5px 0 0',
                            top: 20,
                            right: 0,
                            position: 'absolute',
                            cursor: 'pointer'
                          }}
                        >
                          today
                        </FontIcon>
                      </div>

                      <div
                        className='col-md-4 col-xs-12'
                        style={{position: 'relative'}}
                      >
                        <TextField
                          name='start_time'
                          disabled={!date || date.length < 10}
                          value={startTime}
                          floatingLabelText={this.props.intl.formatMessage(prestationConstants.messages.START_LABEL)}
                          onChange={this.handleTimeFormatChange}
                          mask='99.99'
                          errorText={
                            this.state.errors
                              ? this.state.errors.start_time
                              : undefined
                          }
                          placeholderMandatory={true}
                        />

                        <TimePicker
                          name='start_time'
                          divStyle={{display: 'none'}}
                          locale={this.props.intl.locale}
                          onChange={this.handleTimeChange}
                          getField={this.handleSetStartRef}
                        />

                        <FontIcon
                          onClick={() => this.startTimePicker.focus()}
                          className='material-icons'
                          style={{
                            margin: '20px 5px 0 0',
                            top: 20,
                            right: 0,
                            position: 'absolute',
                            cursor: 'pointer'
                          }}
                        >
                          schedule
                        </FontIcon>
                      </div>

                      <div
                        className='col-md-4 col-xs-12'
                        style={{position: 'relative'}}
                      >
                        <TextField
                          name='end_time'
                          disabled={!this.state.proposal.start_time || this.state.proposal.start_time.length < 5}
                          value={endTime}
                          floatingLabelText={this.props.intl.formatMessage(prestationConstants.messages.END_LABEL)}
                          onChange={this.handleTimeFormatChange}
                          mask='99.99'
                          errorText={
                            this.state.errors
                              ? this.state.errors.end_time
                              : undefined
                          }
                          placeholderMandatory={true}
                        />

                        <TimePicker
                          name='end_time'
                          divStyle={{display: 'none'}}
                          locale={this.props.intl.locale}
                          onChange={this.handleTimeChange}
                          getField={this.handleSetEndRef}
                        />

                        <FontIcon
                          onClick={() => this.endTimePicker.focus()}
                          className='material-icons'
                          style={{
                            margin: '20px 5px 0 0',
                            top: 20,
                            right: 0,
                            position: 'absolute',
                            cursor: 'pointer'
                          }}
                        >
                          schedule
                        </FontIcon>
                      </div>
                    </div>

                    <div className='row'>
                      {
                        this.state.errors.proposal
                          ?
                            <div
                              className='col-md-12 col-xs-12'
                              style={{
                                color: 'red',
                                fontSize: 13,
                                textAlign: 'center'
                              }}
                            >
                              {this.state.errors.proposal}
                            </div>
                          : undefined
                      }

                      {
                        this.state.loadingAvailability
                          ? <CircularProgress
                            size={50}
                            style={{
                              width: '100%',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                          />
                          : <React.Fragment>
                            {
                              this.state.availabilities.length
                                ? <React.Fragment>
                                    <div
                                      className='col-md-offset-3 col-md-6 col-xs-12'
                                    >
                                      <Availability
                                        loadingAvailability={this.state.loadingAvailability}
                                        availabilities={this.state.availabilities}
                                        start_time={this.state.proposal.start_time}
                                        end_time={this.state.proposal.end_time}
                                        handleChangeAvailability={this.handleChangeAvailability}
                                        handleTimeChange={this.handleSelectAvailability}
                                      />
                                    </div>

                                  <div
                                    className='col-md-offset-3 col-md-6 col-xs-12'
                                    style={{paddingTop: 10}}
                                  >
                                    <RaisedButton
                                      primary={true}
                                      label={this.props.intl.formatMessage(prestationConstants.messages.SEND_PROPOSITION_LABEL)}
                                      disabled={
                                        !this.state.proposal.start_time ||
                                        !this.state.proposal.end_time ||
                                        this.state.disableSubmit
                                      }
                                      onClick={this.handleSendProposal}
                                      style={{width: '100%'}}
                                      labelStyle={{fontSize: 13}}
                                    />
                                  </div>
                                </React.Fragment>
                                : undefined
                            }
                          </React.Fragment>
                      }
                    </div>
                  </div>
                ]}
              />
              <Divider />
            </React.Fragment>
            : undefined
        }
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state) => ({
  user: state.User.user,
})

const mapActionsToProps = (dispatch) => ({
  prestationActions: bindActionCreators(prestationActions, dispatch)
})

export default connect(
  mapStateToProps,
  mapActionsToProps
)(injectIntl(ProposalFormPanel))


// WEBPACK FOOTER //
// ./src/components/applicant/prestation/dashboard/ProposalFormPanel.js